import type { UserSession } from 'types';
import resolveUserDob from 'utils/resolveUserDob';

type UserBackground = {
  streetAddress?: string;
  cityAddress?: string;
  stateAddress?: string;
  zipAddress?: string;
  ethnicity?: string;
  grade?: string;
  birthday?: string | Date | null;
  parentPhoneNumber?: string;
};

type RawUserSession = UserSession & {
  background?: UserBackground;
  academics?: {
    school?: { schoolName?: string; gpa?: string };
  };
};

/**
 * API stores address/demographics on `background` and school on `academics`;
 * flatten for UI consumers.
 */
export default function normalizeUserSession(user: RawUserSession): UserSession {
  const bg = user.background ?? {};
  const schoolName =
    user.schoolName ?? user.academics?.school?.schoolName ?? '';
  const dob = resolveUserDob(user);

  return {
    ...user,
    permissions: user.permissions ?? [],
    streetAddress: user.streetAddress ?? bg.streetAddress ?? '',
    cityAddress: user.cityAddress ?? bg.cityAddress ?? '',
    stateAddress: user.stateAddress ?? bg.stateAddress ?? '',
    zipAddress: user.zipAddress ?? bg.zipAddress ?? '',
    ethnicity: user.ethnicity ?? bg.ethnicity ?? '',
    gradeLevel: user.gradeLevel ?? bg.grade ?? '',
    schoolName,
    dob,
  };
}
